export const SET_IS_LOADING = "SET_IS_LOADING";
